import { render, staticRenderFns } from "./JornadaTrabalho.vue?vue&type=template&id=dcb073ac"
import script from "./JornadaTrabalho.vue?vue&type=script&lang=js"
export * from "./JornadaTrabalho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports